var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
        [
          _c(
            "c-table",
            {
              ref: "healthTable",
              attrs: {
                title: "건강 유해성",
                merge: _vm.grid.merge,
                columns: _vm.grid.columns,
                data: _vm.ghsClassBase.healthGhsClassBase,
                filtering: false,
                columnSetting: false,
                usePaging: false,
                editable: _vm.editable,
                selection: "multiple",
                rowKey: "mdmGhsClassficationBaseId",
              },
              on: { "table-data-change": _vm.dataChange },
            },
            [
              _c(
                "template",
                { slot: "table-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: {
                              showLoading: false,
                              label: "추가",
                              icon: "add",
                            },
                            on: { btnClicked: _vm.addHealthGhsClassBase },
                          })
                        : _vm._e(),
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: {
                              url: _vm.saveUrl,
                              isSubmit: _vm.isSaveHealth,
                              param: _vm.saveData.health,
                              mappingType: "PUT",
                              label: "저장",
                              icon: "save",
                            },
                            on: {
                              beforeAction: _vm.saveHealthGhsClassBaseInfo,
                              btnCallback: _vm.saveHealthGhsClassBaseCallback,
                            },
                          })
                        : _vm._e(),
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: { label: "삭제", icon: "remove" },
                            on: { btnClicked: _vm.deleteHealthGhsClassBase },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
        [
          _c(
            "c-table",
            {
              ref: "envTable",
              attrs: {
                title: "환경 유해성",
                merge: _vm.grid.merge,
                columns: _vm.grid.columns,
                data: _vm.ghsClassBase.envGhsClassBase,
                filtering: false,
                columnSetting: false,
                usePaging: false,
                editable: _vm.editable,
                selection: "multiple",
                rowKey: "mdmGhsClassficationBaseId",
              },
              on: { "table-data-change": _vm.dataChange },
            },
            [
              _c(
                "template",
                { slot: "table-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: {
                              showLoading: false,
                              label: "추가",
                              icon: "add",
                            },
                            on: { btnClicked: _vm.addEnvGhsClassBase },
                          })
                        : _vm._e(),
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: {
                              url: _vm.saveUrl,
                              isSubmit: _vm.isSaveEnv,
                              param: _vm.saveData.env,
                              mappingType: "PUT",
                              label: "저장",
                              icon: "save",
                            },
                            on: {
                              beforeAction: _vm.saveEnvGhsClassBaseInfo,
                              btnCallback: _vm.saveEnvGhsClassBaseCallback,
                            },
                          })
                        : _vm._e(),
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: { label: "삭제", icon: "remove" },
                            on: { btnClicked: _vm.deleteEnvGhsClassBase },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }